module.exports = __webpack_public_path__ + "static/media/stepperCheck.86d74ddb.svg";